import first from "lodash/first";
import { forwardRef } from "react";
import { graphql, useFragment } from "react-relay";

import type { ContentItemRenderVariantProps } from "~/components/content/content-item-render/types";
import type { homeAroundMorningStudioSecondaryContentItemContent$key } from "~/queries/__generated__/homeAroundMorningStudioSecondaryContentItemContent.graphql";

import {
  Container,
  Content,
  Headline,
  SponsorContainer,
  SponsorName,
  SponsorType,
  StyledEntityLink,
} from "./styles";

export type Props = {
  reference: homeAroundMorningStudioSecondaryContentItemContent$key;
} & ContentItemRenderVariantProps;

export const ContentItemHomeAroundMorningStudioSecondary = forwardRef<HTMLDivElement, Props>(
  ({ className, onClick, provider, reference: reference_ }, reference) => {
    const content = useFragment(
      graphql`
        fragment homeAroundMorningStudioSecondaryContentItemContent on Content {
          entityId
          topics {
            sponsor {
              name
              type
            }
          }
          ...entityLink
        }
      `,
      reference_,
    );

    const sponsor = first(content?.topics)?.sponsor;
    const sponsorName = sponsor?.name;
    const sponsorType = sponsor?.type;

    return (
      <Container className={className} ref={reference}>
        <StyledEntityLink reference={content} onClick={() => onClick?.(content.entityId)}>
          <Content>
            <Headline>
              {provider.headline({
                preferSocialHeadline: true,
                useContentSponsorStyle: false,
              })}
            </Headline>
          </Content>
        </StyledEntityLink>
        <SponsorContainer>
          <SponsorType>{sponsorType}</SponsorType>
          <SponsorName>{sponsorName}</SponsorName>
        </SponsorContainer>
      </Container>
    );
  },
);

ContentItemHomeAroundMorningStudioSecondary.displayName =
  "ContentItemHomeAroundMorningStudioSecondary";
